const PROFICIENCY_LEVELS = {
  ENTRY: "entry",
  INTERMEDIATE: "intermediate",
  ADVANCED: "advanced",
  MASTERY: "mastery",
};

export const PROFICIENCY_LEVEL_IDS = {
  NONE: 0,
  ENTRY: 1,
  INTERMEDIATE: 2,
  ADVANCED: 3,
  MASTERY: 4,
};

export const getProficiencyLevelLabel = (
  proficiencyLevel,
  prefix = "lxpComponents.proficiencyLevel"
) => {
  if (
    proficiencyLevel == PROFICIENCY_LEVEL_IDS.ENTRY ||
    proficiencyLevel == PROFICIENCY_LEVELS.ENTRY
  )
    return `${prefix}.entry`;
  if (
    proficiencyLevel == PROFICIENCY_LEVEL_IDS.INTERMEDIATE ||
    proficiencyLevel == PROFICIENCY_LEVELS.INTERMEDIATE
  )
    return `${prefix}.intermediate`;
  if (
    proficiencyLevel == PROFICIENCY_LEVEL_IDS.ADVANCED ||
    proficiencyLevel == PROFICIENCY_LEVELS.ADVANCED
  )
    return `${prefix}.advanced`;
  if (
    proficiencyLevel == PROFICIENCY_LEVEL_IDS.MASTERY ||
    proficiencyLevel == PROFICIENCY_LEVELS.MASTERY
  )
    return `${prefix}.mastery`;

  return `${prefix}.none`;
};

export default PROFICIENCY_LEVELS;
